var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex overflow-hidden max-height wrap",
      staticStyle: { "flex-direction": "column" },
    },
    [
      _c("PageHeader", {
        staticStyle: { flex: "0 0!important" },
        attrs: { "no-padding": "" },
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "overflow-hidden", staticStyle: { flex: "1 0" } },
        [
          _c("ExecutionResultsDialog", {
            ref: "executionResultsDialog",
            attrs: { title: "Fetching import events" },
          }),
          _vm._v(" "),
          _c("IngestionResultsLogDialog", { ref: "ingestionResultsDialog" }),
          _vm._v(" "),
          _c(
            "v-navigation-drawer",
            {
              staticClass: "card-bg-2 hf-scrollbar-light",
              attrs: { left: "", permanent: "", clipped: "" },
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-list",
                    { staticClass: "transparent", attrs: { dense: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "headline align-center" },
                        [
                          _c("v-icon", { attrs: { medium: "" } }, [
                            _vm._v("filter_alt"),
                          ]),
                          _vm._v("\n            Filters\n            "),
                          _c(
                            "SecondaryBtn",
                            {
                              staticClass: "mr-1",
                              staticStyle: { "min-width": "0" },
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.clearFilters()
                                },
                              },
                            },
                            [_vm._v("CLEAR")]
                          ),
                          _vm._v(" "),
                          _c("SecondaryBtn", {
                            staticClass: "mx-0",
                            staticStyle: { "min-width": "0" },
                            attrs: {
                              "no-icon-padding": "",
                              small: "",
                              icon: "refresh",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refreshResults()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [_vm._v("Event dates")]),
                      _vm._v(" "),
                      _c("DateRange", {
                        ref: "dateRange",
                        attrs: {
                          "hide-clear": "",
                          shortcuts: _vm.dateRangeShortcuts,
                          rounded: "",
                          solo: "",
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          "no-arrows": "",
                          numColumns: 1,
                          twoLine: "",
                        },
                        model: {
                          value: _vm.queryFilters.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryFilters, "dateRange", $$v)
                          },
                          expression: "queryFilters.dateRange",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.dateRange.prevRange()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "success" } }, [
                                _vm._v("arrow_back"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.dateRange.nextRange()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "success" } }, [
                                _vm._v("arrow_forward"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-2" }),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("Event type and outcome status"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.statusTypes, function (item, i) {
                        return _c(
                          "v-list-tile",
                          { key: i },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "body-1 align-center d-flex",
                                staticStyle: { flex: "0 0 115px" },
                              },
                              [
                                _c("v-icon", {
                                  staticClass: "mr-1",
                                  domProps: { innerHTML: _vm._s(item.icon) },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    ":\n              "
                                ),
                                _c("v-spacer"),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn-toggle",
                              {
                                attrs: { multiple: "" },
                                model: {
                                  value: _vm.filters[item.id],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, item.id, $$v)
                                  },
                                  expression: "filters[item.id]",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  { attrs: { value: "pass", small: "" } },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "success" } },
                                      [_vm._v("check_circle")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  { attrs: { value: "fail", small: "" } },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "error" } },
                                      [_vm._v("error")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-2" }),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("\n            File types used\n          "),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.dataImporters, function (item, index) {
                        return _c(
                          "v-list-tile",
                          {
                            key: `filter-service-${index}`,
                            staticClass: "pa-0",
                          },
                          [
                            _c("v-checkbox", {
                              staticClass: "my-0",
                              attrs: {
                                color: "success",
                                "hide-details": "",
                                label: item.name,
                                value: item.serviceLink,
                              },
                              model: {
                                value: _vm.filters.services,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "services", $$v)
                                },
                                expression: "filters.services",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("\n            Other filters\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { staticClass: "pa-0 mb-2" },
                        [
                          _c("v-checkbox", {
                            staticClass: "my-0",
                            attrs: {
                              color: "success",
                              "hide-details": "",
                              label: "Only show the latest import versions",
                            },
                            model: {
                              value: _vm.otherFilters.latestVersionOnly,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.otherFilters,
                                  "latestVersionOnly",
                                  $$v
                                )
                              },
                              expression: "otherFilters.latestVersionOnly",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { staticClass: "pa-0" },
                        [
                          _c("v-checkbox", {
                            staticClass: "my-0",
                            attrs: {
                              color: "success",
                              "hide-details": "",
                              label:
                                "Don't show ingestions that were rolled back",
                            },
                            model: {
                              value: _vm.otherFilters.skipRolledBackIngestions,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.otherFilters,
                                  "skipRolledBackIngestions",
                                  $$v
                                )
                              },
                              expression:
                                "otherFilters.skipRolledBackIngestions",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "overflow-hidden max-height card-bg-1",
              staticStyle: { position: "relative" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "mb-1 overflow-hidden max-height position-relative",
                },
                [
                  _c("Subheader", {
                    staticStyle: { flex: "0 0" },
                    attrs: {
                      color: "#f3f3f3",
                      flat: "",
                      light: "",
                      lightSearch: "",
                      rounded: "",
                      search: "import events",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function () {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "clickable",
                                              attrs: { color: "info" },
                                            },
                                            on
                                          ),
                                          [_vm._v("info_outline")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " Use the filename, COC code or any other field to search. "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.queryFilters.searchText,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryFilters, "searchText", $$v)
                      },
                      expression: "queryFilters.searchText",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.loading.ingestionResults
                    ? _c("PageLoader", {
                        staticClass: "mt-5",
                        attrs: { "resource-name": "import results" },
                      })
                    : _vm.filteredImportIds.length == 0
                    ? _c("NoResultsFound", {
                        attrs: {
                          text: "No import events found. <br/> Expand your date range or clear some filters.",
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "overflow-auto",
                          staticStyle: { height: "Calc(100% - 64px)" },
                        },
                        [
                          _c(
                            "v-subheader",
                            [
                              _c("div", { staticClass: "mr-1" }, [
                                _vm._v(
                                  _vm._s(_vm.filteredImportIds.length) +
                                    " " +
                                    _vm._s(
                                      _vm.pluralize(
                                        "import event",
                                        _vm.filteredImportIds.length
                                      )
                                    ) +
                                    " found."
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.importCounts,
                                function (importCount, key) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: `importCount-${key}`,
                                      staticClass: "body-1",
                                      attrs: { small: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(importCount) +
                                          " " +
                                          _vm._s(
                                            _vm.pluralize(
                                              _vm.statusTypes[key].label,
                                              importCount
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.filteredImportIds, function (indexId, j) {
                            return _c("ImportCard", {
                              key: `import-${j}`,
                              attrs: { indexId: indexId },
                              on: {
                                "show:logs": function ($event) {
                                  return _vm.showIngestionLogs(indexId)
                                },
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-xs-center py-4" }, [
                            _vm._v("\n            End of results\n          "),
                          ]),
                        ],
                        2
                      ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }